require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-voodoos-bs-semantic-ui-react.json") })
        }
      }, "path---package-unpublished-voodoos-bs-semantic-ui-react");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-voodoos-bs-semantic-ui-react!./.cache/json/package-unpublished-voodoos-bs-semantic-ui-react.json
// module id = 973
// module chunks = 231608221292675